import React, { useEffect, useState } from "react";
import styles from "./Qrcode.module.scss";
import QRCode from "react-qr-code";
import { useDispatch } from "react-redux";
import Button from "../button/Button";
import {
  TrackOrderStatusAction,
  payOrderAction,
  trackOrderAction,
} from "../../redux/actions/orderStatus/orderStatusAction";
import PendingPaymentCard from "../PendingPaymentCard/PendingPaymentCard";
import SuccessfulPaymentCard from "../SuccessfulPaymentCard/SuccessfulPaymentCard";

type QRLinkProps = {
  reference: string;
};

const QrCode = ({ reference }: QRLinkProps) => {
  const dispatch = useDispatch();
  const [qrcodeimg, setQrcodeimage] = useState("");
  const [componentData, setComponentData] = React.useState<any>({
    pendingfor5min: false,
    isSuccessful: undefined
  });
  const payload = {
    reference: reference,
    paymentOption: "NQR",
  };

  const MadePayment = () => {
    TrackOrderStatusAction(
      payload,
      dispatch,
      updatePendingStatus
    )
    dispatch(trackOrderAction({ eventname: "MADE-PAYMENT", orderReference: payload.reference }, () => { }))
  };
  const updatePendingStatus = (data: any) => {
    console.log("Close update", data);
    setComponentData({
      ...componentData,
      pendingfor5min: data != "completed",
      isSuccessful: data == "completed",
    });
    console.log({componentData})
  };
  useEffect(() => {
    payOrderAction(payload, dispatch, (data: any) => {
      setQrcodeimage(data?.data?.paymentDetail?.redirectUrl);
    });
  }, []);

  return (
    <>
      {componentData?.isSuccessful ? <SuccessfulPaymentCard paymentmethod="NQR" /> :
        componentData?.pendingfor5min ? (<PendingPaymentCard paymentmethod="Transfer" />) :
          (<div className={styles.container}>
            <div className={styles.scan}>
              Scan the QR code below with your mobile
              <br /> banking app to complete payment
            </div>
            {qrcodeimg && (
              <div className={styles.qrCode}>
                <img src={qrcodeimg} alt="qrcode image" height={"250"} />
                <div>
                  <Button
                    width="100%"
                    onClick={() => MadePayment()}
                    style={{
                      color: "#ffffff",
                      backgroundColor: "#19943c",
                    }}
                    value="I’ve sent the money"
                  />
                </div>
              </div>
            )}
          </div>
          )}
    </>
  );
};

export default QrCode;
